// Only works in dev env

'use client';

// react-scan must be imported before react
import { c as _c } from "react/compiler-runtime";
import { scan } from 'react-scan';
import { JSX, useEffect } from 'react';
export function ReactScan() {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  useEffect(_temp, t0);
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <></>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}
function _temp() {
  if (typeof window !== "undefined" && window.parent !== window) {
    return;
  }
  scan({
    enabled: true
  });
}